import { render, staticRenderFns } from "./Create-Enquiry.vue?vue&type=template&id=5128646a"
import script from "./Create-Enquiry.vue?vue&type=script&lang=js"
export * from "./Create-Enquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports